import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  href = '#',
  className = '',
  onClick
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      if (href === '#') {
        e.preventDefault();
      }
      onClick();
    }
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center px-8 py-4 
        bg-gold hover:bg-gold-hover text-black 
        font-montserrat font-bold text-lg md:text-xl rounded-sm
        transition-colors duration-300 shadow-lg
        animate-glow-pulse text-center
        ${className}
      `} data-id="element-227">
      {children}
    </motion.a>;
}